var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFreeBreakfast(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_15_223)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.3333 5H9.99996C8.16663 5 6.66663 6.5 6.66663 8.33333V21.6667C6.66663 25.35 9.64996 28.3333 13.3333 28.3333H23.3333C27.0166 28.3333 30 25.35 30 21.6667V16.6667H33.3333C35.1833 16.6667 36.6666 15.1667 36.6666 13.3333V8.33333C36.6666 6.5 35.1666 5 33.3333 5ZM33.3333 13.3333H30V8.33333H33.3333V13.3333ZM8.33329 31.6667H31.6666C32.5833 31.6667 33.3333 32.4167 33.3333 33.3333C33.3333 34.25 32.5833 35 31.6666 35H8.33329C7.41663 35 6.66663 34.25 6.66663 33.3333C6.66663 32.4167 7.41663 31.6667 8.33329 31.6667Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_15_223"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFreeBreakfast);
export default __webpack_public_path__ + "static/media/free_breakfast.862d8706dfe51769178fa37b0f3125e4.svg";
export { ForwardRef as ReactComponent };